export function useAboutModal() {
  const isOpen = useState('about-modal-open', () => false)
  return {
    close: () => { isOpen.value = false },
    isOpen,
    open: () => { isOpen.value = true },
  }
}
